import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmMenuService } from 'src/app/shared/services/confirm-menu/confirm-menu.service';

@Component({
  selector: 'app-waiting-room-list',
  standalone: true,
  imports: [TranslateModule, MatButtonModule, MatIconModule, MatTooltipModule],
  template: `
    <div class="waiting-room-wrapper" [class.is-collapsible]="collapsible()">
      @if (collapsible()) {
        <button class="settings-section-header" [class.expanded]="isExpanded()" (click)="toggleExpand()">
          <div class="flex items-center gap-1.5">
            <div class="waiting-pulse-dot"></div>
            <span class="text-[12px] font-semibold tracking-wider">{{ 'VideoCall.Participants.WaitingTitle' | translate }} ({{ participants().length }})</span>
          </div>
          <mat-icon class="toggle-icon" [class.expanded]="isExpanded()">chevron_right</mat-icon>
        </button>
      } @else {
        <div class="waiting-section-header">
          <div class="flex items-center gap-1.5">
            <div class="waiting-pulse-dot"></div>
            <span class="text-[12px] font-semibold tracking-wider">{{ 'VideoCall.Participants.WaitingTitle' | translate }} ({{ participants().length }})</span>
          </div>
        </div>
      }

      @if (!collapsible() || isExpanded()) {
        <div class="settings-body d-flex flex-column gap-1">
          @for (w of participants(); track w.id) {
            <div class="waiting-item">
              <div class="flex items-center gap-2 flex-1 min-w-0">
                @if (w.email) {
                  <span class="text-[13px] font-medium text-[var(--skz-text-primary)] truncate" [matTooltip]="w.email">{{ w.email }}</span>
                  @if (w.name && w.name !== w.email) {
                    <span class="px-2 py-0.5 rounded-full bg-slate-100 text-slate-600 text-[10px] font-medium border border-slate-200 truncate max-w-[120px] flex-shrink-0" [matTooltip]="w.name">{{ w.name }}</span>
                  }
                } @else {
                  <span class="text-[13px] font-medium text-[var(--skz-text-primary)] truncate" [matTooltip]="w.name">{{ w.name }}</span>
                }
              </div>
              <div class="actions flex items-center gap-1">
                <button mat-icon-button (click)="admit.emit(w.id)" [matTooltip]="'VideoCall.Participants.Admit' | translate">
                  <mat-icon class="text-[15px] text-[var(--skz-primary-color)]">check</mat-icon>
                </button>
                <button mat-icon-button (click)="onReject($event, w.id)" [matTooltip]="'VideoCall.Participants.Reject' | translate">
                  <mat-icon class="text-[15px] text-red-500">close</mat-icon>
                </button>
              </div>
            </div>
          }
        </div>
      }
    </div>
  `,
  styleUrls: ['./waiting-room-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WaitingRoomListComponent {
  participants = input.required<any[]>();
  collapsible = input(true);
  admit = output<string>();
  reject = output<string>();

  private confirmMenuService = inject(ConfirmMenuService);

  isExpanded = signal(false);

  toggleExpand(): void {
    if (!this.collapsible()) return;
    this.isExpanded.update((val) => !val);
  }

  onReject(event: MouseEvent, participantId: string): void {
    event.stopPropagation();
    this.reject.emit(participantId);
  }
}
